module.exports = __webpack_public_path__ + "static/media/P02.3b3a1141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/panel_strobe/P02.png
// module id = 192
// module chunks = 0